/**
 * Copyright 2021 Olympe S.A.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { registerBrick } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import { useOlympeTheme } from './mui';

import React, {  } from 'react';
import { ThemeProvider } from '@mui/material/styles';

import MUIChip from "@mui/material/Chip";

/**
 * Provide a Label visual component using MUI Typography
 */
export default class Chip extends ReactBrick {

    /**
     * @override
     */
    setupExecution($) {
        return $.observe('Hidden');
    }

    /**
     * @override
     */
    static getReactComponent($) {
        return (props) => {
            const [hidden] = props.values;
            const theme = useOlympeTheme($);
            const clickable = useProperty($, 'Clickable', true);
            const override = useProperty($, 'Color Override', true);

            let color, bgColor, border;
            color = useProperty($, 'Color Type', true);
            if (!color) {
                color = 'info';
            }
            if (['primary', 'secondary', 'success', 'info', 'warning', 'error'].includes(color.toLowerCase())) {
                color = theme.palette[color.toLowerCase()].main ?? '#06A80B';
            }
            if (override) {
                color = override.toHexString();
            }

            // Getting values of the chip out of the configuration
            bgColor = color + '30';
            const borderWidth = useProperty($, 'Border Width', true) ?? 0;
            const borderStyle = useProperty($, 'Border Style', true) ?? 'solid';
            const borderColorProp = useProperty($, 'Border Color', true)?.toHexString();
            const borderColor = borderColorProp !== '#00000000' ? borderColorProp : color;
            border = borderWidth + 'px ' + borderStyle + ' ' + borderColor;

            const sx = {
                border,
                backgroundColor: bgColor,
                color,
                textAlign: 'center',
                fontWeight: 600
            };


            return !hidden && (
                <ThemeProvider theme={theme}>
                    <MUIChip label={useProperty($, 'Text', true)} sx={sx} onClick={clickable ? () => $.trigger('On Click') : undefined} />
                </ThemeProvider>
            );
        };
    }
}


registerBrick('0191bd213c0ab277daa9', Chip);
